/* eslint-disable jsx-a11y/anchor-is-valid */
import { LoadManager } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'
import Chat from './Chat'
import { ModalMessages } from './styles'

function participantNames(conversation) {
  return conversation?.participants?.map((person) => person.fullName).join(', ')
}

function MessagesModal({
  selected, listLoading, messageService, onClose, onRead, onMessageAdded, licensing,
}) {
  function renderBody() {
    if (listLoading) return <LoadManager loading={listLoading} />

    if (!selected) {
      return (
        <div className="empty">
          <div className="empty-icon">
            <i className="fa-3x fas fa-comments" />
          </div>
          <p className="empty-title h5">Conversa não encontrada</p>
          <p className="empty-subtitle">Volte para a lista e selecione uma conversa disponível.</p>
        </div>
      )
    }

    return (
      <Chat
        selected={selected}
        messageService={messageService}
        onRead={onRead}
        onMessageAdded={onMessageAdded}
        licensing={licensing}
      />
    )
  }

  return (
    <ModalMessages className="modal active">
      <a type="button" className="modal-overlay" aria-label="Fechar" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header">
          <a
            type="button"
            className="btn btn-clear float-right"
            onClick={onClose}
          />
          <div className="modal-title h5 text-primary">
            {selected ? selected.title : 'Conversa não encontrada'}
          </div>
          {
            selected && (
              <div className="modal-subtitle">
                {
                  selected?.participants?.length
                    ? `${participantNames(selected)}`
                    : ''
                }
              </div>
            )
          }
        </div>
        <div className="divider" />
        <div className="modal-body">
          {renderBody()}
        </div>
      </div>
    </ModalMessages>
  )
}

MessagesModal.propTypes = {
  selected: PropTypes.objectOf(PropTypes.any),
  listLoading: PropTypes.bool,
  messageService: PropTypes.objectOf(PropTypes.func).isRequired,
  onClose: PropTypes.func.isRequired,
  onRead: PropTypes.func.isRequired,
  onMessageAdded: PropTypes.func.isRequired,
  licensing: PropTypes.objectOf(PropTypes.any),
}

MessagesModal.defaultProps = {
  selected: null,
  listLoading: false,
  licensing: null,
}

export default MessagesModal
